import React, {useEffect, useState} from "react";
import {DetailsWrapper} from "../../components/details-wrapper/details-wrapper";
import {PublisherService} from "../../services/publisher.service";
import {PublisherCustomProfileModel} from "../../models/publisher/publisher-custom-profile.model";
import {Grid} from "@mui/material";
import {StyledButton} from "../../components/ui-base/button";
import {IProfileData, PublisherCreateProfile} from "../../components/publisher/create-profile/create-profile";
import {showSnackError, showSnackSuccess, toggleLoader} from "../../store/global/global-slice";
import {useDispatch} from "react-redux";
import {useHistory} from "react-router-dom";
import {PublisherModel} from "../../models/publisher.model";
import {useTranslation} from "react-i18next";

const PublisherEditDataProfilePage = () => {
    const [publisherProfile, setPublisherProfile] = React.useState<PublisherCustomProfileModel>(null);
    const [publisher, setPublisher] = React.useState<PublisherModel>(null);
    const [profileData, setProfileData] = useState<IProfileData>(null);
    const dispatch = useDispatch();
    const history = useHistory();
    const { t } = useTranslation(['publisher', 'common']);

    const loadDataProfile = async () => {
        const profile = await PublisherService.getMe();
        setPublisher(profile);
        const dataProfile: PublisherCustomProfileModel = await PublisherService.getProfileData(profile.id);
        setPublisherProfile(dataProfile);
    }

    useEffect(() => {
        loadDataProfile();
    }, []);

    const submitProfile = async () => {
        dispatch(toggleLoader(true));
        if (profileData) {
            if (profileData.valid) {
                const res = await PublisherService.updateProfileData(
                    publisher.id,
                    profileData
                );

                if (res) {
                    dispatch(showSnackSuccess(t('editProfile.profileChanged')));
                    history.push('/publisher/profile');
                }
            } else {
                dispatch(showSnackError(profileData.errorText));
                dispatch(toggleLoader(false));
            }
        } else {
            dispatch(showSnackError(t('editProfile.validError')));
            dispatch(toggleLoader(false));
        }
    }

    const back = () => {
        history.goBack();
    }

    return (
        <DetailsWrapper description={t('editProfile.pageDesc')}>
            <Grid container direction={'column'}>
                <Grid container direction="row" justifyContent="flex-end" spacing={2}>
                    <Grid item>
                        <StyledButton type="button" color={"transparent"} onClick={back} style={{marginRight: '10px'}}>
                            {t('common:cancel')}
                        </StyledButton>
                        <StyledButton type="button" onClick={submitProfile}>
                            {t('common:save')}
                        </StyledButton>
                    </Grid>
                </Grid>

                {publisherProfile &&
                <PublisherCreateProfile
                    handleProfileData={(data: IProfileData) => {setProfileData(data)}}
                    initProfile={publisherProfile.custom_profile || publisherProfile.main_increasing_categories}
                />
                }
            </Grid>
        </DetailsWrapper>
    )
}

export default PublisherEditDataProfilePage;
